'use strict';

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/locale-provider/style/index.js
// module id = 411
// module chunks = 0